import React from 'react';
import { Link } from 'react-router-dom';
import '../css/pricing.css';

function Pricing() {
  return (
    <div className="pricing-container">
      <h1 className="pricing-title">Pricing</h1>
      
      <p className="pricing-description">
        Simple and transparent pricing for your organization.
      </p>

      <div className="pricing-box">
        <h2 className="pricing-amount">₦10,000 / month</h2>
        <p className="pricing-note">One flat rate. No hidden fees. Cancel anytime.</p>

        <div className="pricing-features">
          <h3 className="features-title">Key Features:</h3>
          <ul className="pricing-features">
            <li>Upload documents (up to 100MB)</li>
            <li>AI-powered Q&A on your data</li>
            <li>Automatic knowledge updates</li>
            <li>Organization dashboard</li>
            <li>Role-based access control</li>
            <li>Secure storage & encryption</li>
            <li>Priority email & chat support</li>
          </ul>
        </div>

        <Link to="/auth/signup" className="pricing-button">
          Get Started
        </Link>
      </div>
    </div>
  );
}

export default Pricing;

